<template>
  <div class="modal-description">
    <div class="modal-text">
      <div class="modal-text-content" v-html="description">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['description']
}
</script>

<style lang="scss">
  .modal-description {
    padding: 48px 120px;
    @media only screen and (max-width: 768px) {
      padding: 24px;
    }
    .modal-media {
      margin-bottom: 48px;
      img, video {
        max-width: 100%;
        max-height: 480px;
        height: auto;
      }
    }
    .modal-text-title {
      margin-top: 16px;
      margin-bottom: 24px;
      font-family: CAPUTTRIAL;
      font-size: 32px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #244a56;
    }
    .modal-text-content {
      font-family: Georgia;
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: #18333c;
    }
    .modal-text-date {
      font-family: Rubik;
      font-size: 12px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #9a6969;
    }
  }
</style>
